import { Routes } from "@angular/router";

export const authenticatedPresenceRoutes: Routes = [
  {
    path: "",
    pathMatch: "full",
    loadComponent: () =>
      import("./mobile-presence-list-page/mobile-presence-list-page.component").then(
        (moduleExports) => moduleExports.MobilePresenceListPageComponent
      ),
  },
];
